<template>
	<div>
		<a-row>
			<a-col :span="12">
				<div>
					<div class="title">
						<div style="margin-left: 10px;font-weight: bold;float: left;margin-top: 10px;">
							<a-icon type="bars" />
							&nbsp;分类列表
						</div>
						<div style="float: right;margin-top: 6px;margin-right: 25px;"><a-button @click="showModal">添加</a-button></div>
					</div>

					<div>
						<a-table :columns="columns" :dataSource="data">
							<a slot="name" slot-scope="text">{{ text }}</a>
							<span slot="分类名称">
								<a-icon type="pushpin" />
								分类名称
							</span>
							<!-- <a slot="display" slot-scope="text,record">
								<a-switch defaultChecked  v-if="record.display==0" disabled/>
								<a-switch  v-else disabled/>
							</a> -->
							<span slot="action" slot-scope="text, record">
								<!-- <a-button size="small" @click="editAttr(record)">编辑</a-button> -->
								&nbsp;&nbsp;
								<a-popconfirm
								    title="将删除该分类下所有的商品,是否删除？"
								    @confirm="deleteAttr(record.id,record.name,record.productCount)"
								    @cancel="cancel"
								    okText="Yes"
								    cancelText="No"
								>
								<a-button type="danger" size="small">删除</a-button>
								</a-popconfirm>
							</span>
						</a-table>
					</div>
				</div>
			</a-col>
			<!-- <a-col :span="10" class="preview_phone"></a-col> -->
		</a-row>

		<a-modal title="添加分类" :visible="visible" @ok="handleOk" :confirmLoading="confirmLoading" @cancel="handleCancel">
			<a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }" @submit="handleSubmit">
				<a-form-item label="分类">
					<a-input v-decorator="['AttrName', { rules: [{ required: true, message: '请输入分类名称' }] }]" />
				</a-form-item>
				<a-form-item label="排序">
					<a-input-number id="inputNumber" :defaultValue="0" :min="0" :max="100" :v-model="sortNumber" @change="onChange" />(最大100)
				</a-form-item> 
				<!-- <a-form-item label="是否显示">
					<a-switch defaultChecked @change="displayChange"/>
				</a-form-item> -->
			</a-form>
		</a-modal>
	</div>
</template>
<script>
import api from '../../api/Api.js';

const columns = [
	{
		title: '编号',
		dataIndex: 'id',
		key: 'id'
	},
	{
		dataIndex: 'name',
		key: 'name',
		slots: { title: '分类名称' },
		scopedSlots: { customRender: 'name' }
	},
	{
		title: '排序(越大越前)',
		key: 'sort',
		dataIndex: 'sort',
		slots: { title: 'sort' },
		scopedSlots: { customRender: 'sort' }
	},
	{
		title: '商品数量',
		dataIndex: 'productCount',
		key: 'productCount'
	},
	{
		title: '操作',
		key: 'action',
		dataIndex: 'action',
		scopedSlots: { customRender: 'action' }
	}
];

export default {
	data() {
		return {
			data: [],
			columns,
			visible: false,
			confirmLoading: false,
			AttrName: '123132',
			formLayout: 'horizontal',
			form: this.$form.createForm(this, { name: 'coordinated' }),
			sortNumber: 0,
			display:0
		};
	},
	mounted() {
		this.getAttrInfo();
	},
	methods: {
		displayChange(checked) {
			if(checked){
				this.display = 0;
			}else{
				this.display = 1;
			}
		},
		cancel(){
			console.log("取消")
		},
		onChange(value) {
			this.sortNumber = value;
		},
		handleSubmit(e) {
			const that = this;
			this.form.validateFields((err, values) => {
				if (!err) {
					that.AttrName = values.AttrName;
					that.visible = false;
					that.confirmLoading = false;
					that.addType();
				}else{
					that.$message.error(err.AttrName.errors[0].message)
					that.confirmLoading = false;
				}
			});
		},
		addType(){
			const that = this;
			let url = 'api/store/v1/admin/commodity/addType';
			let parm = {
				name: that.AttrName,
				parentId: 0,
				sort: that.sortNumber,
				display: that.display
			};
			
			api.postRequest(url, parm, res => {
				if(res.status == 200){
					this.$message.success("添加成功！")
					that.getAttrInfo();
				}else{
					this.$message.waring(res.message)
				}
			});
		},
		editAttr(record) {
			console.log(record);
		},
		deleteAttr(deleteId,typeName,productCount){
			
			if(typeName == "其他"){
				if(productCount > 0){
					this.$message.warning("[其他]分类不可删除！")
					return;
				}
			}
			
			const that = this;
			let url = 'api/store/v1/admin/commodity/deleteType';
			let parm = {
				id:deleteId
			};
			api.postRequest(url, parm, res => {
				if(res.status == 200){
					this.$message.success("删除成功！")
					console.log(res)
					this.getAttrInfo();
				}else{
					this.$message.waring(res.message)
				}
				
			});
		},
		getAttrInfo() {
			const that = this;
			let url = 'api/store/v1/admin/commodity/typeList';
			let parm = {
				parentId: 0
			};

			api.postRequest(url, parm, res => {
				const data = res.data.data;
				data.forEach((item, index, array) => {
					item.key = item.id;
				});
				that.data = data;
			});
		},
		showModal() {
			this.visible = true;
		},
		handleOk(e) {
			// document.getElementById("submit").click();
			this.confirmLoading = true;
			this.handleSubmit();
		},
		handleCancel(e) {
			console.log('Clicked cancel button');
			this.visible = false;
		}
	}
};
</script>
<style scoped>
.title {
	border: 2px solid gainsboro;
	margin-bottom: 30px;
	margin-top: 25px;
	border-radius: 5px;
	height: 50px;
}
.preview_phone {
	width: 670px;
	height: 670px;
	background-image: url('../../static/phone.png');
	background-size: 100%;
}
.avatar-uploader > .ant-upload {
	width: 128px;
	height: 128px;
}
.ant-upload-select-picture-card i {
	font-size: 32px;
	color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
	margin-top: 8px;
	color: #666;
}
</style>
